import React from "react";
import { useNavigation } from "../hooks/useNavigation";

const Footer: React.FC = () => {
  const { goTo } = useNavigation();
  return <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8 py-3 mt-4 text-blue-200 text-sm py-6">Made with love by <button className="hover:underline" onClick={() => goTo("/donate")}>LaPerle</button></div>;
};

export default Footer;
